





import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class ShippingQuoteStatusChip extends Vue {
  @Prop()
  public situacao: any;

  @Prop({ default: true })
  public small: boolean;

  getColor() {
    if (this.situacao.podeAlterar) {
      return 'orange';
    }
    if (this.situacao.finalizadoOk === false) {
      return 'red';
    }
    return 'green';
  }

  getIcon() {
    if (this.situacao.podeAlterar) {
      return 'loupe';
    }
    if (this.situacao.finalizadoOk == null) {
      return 'fa-clock';
    }
    if (this.situacao.finalizadoOk == true) {
      return 'check';
    }
    if (this.situacao.finalizadoOk == false) {
      return 'fa-circle-exclamation';
    }
  }
}
